import React, { useState } from 'react';
import { theme } from '../../styles/theme';
import { getUserProfile, saveUserProfile } from '../../services/userProfileService';

interface WelcomeProps {
    onComplete: () => void;
}

const Welcome: React.FC<WelcomeProps> = ({ onComplete }) => {
    const [mode, setMode] = useState<'choice' | 'personalize'>('choice');
    const [name, setName] = useState('');
    const [isGuest, setIsGuest] = useState(false);

    const handleContinueAsGuest = () => {
        setIsGuest(true);
        setMode('personalize');
    };

    const handleLogin = () => {
        setIsGuest(false);
        setMode('personalize');
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!name.trim()) {
            alert('Please enter a name');
            return;
        }

        const profile = getUserProfile();
        profile.name = name;
        profile.nameRu = name; // For now, same name in both languages
        saveUserProfile(profile);

        // Call the onComplete callback to transition to game
        onComplete();
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: theme.gradients.nature,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
        }}>
            <div style={{
                background: theme.colors.cardBg,
                borderRadius: '20px',
                padding: '40px',
                maxWidth: '500px',
                width: '100%',
                boxShadow: theme.shadows.lg,
                textAlign: 'center',
            }}>
                {mode === 'choice' ? (
                    <>
                        <div style={{
                            fontSize: '64px',
                            marginBottom: '20px',
                        }}>
                            🧩
                        </div>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: 700,
                            color: theme.colors.textPrimary,
                            marginBottom: '12px',
                        }}>
                            Welcome to Puzzzled
                        </h1>
                        <p style={{
                            fontSize: '16px',
                            color: theme.colors.textSecondary,
                            marginBottom: '40px',
                        }}>
                            Beautiful jigsaw puzzles for everyone
                        </p>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <button
                                onClick={handleContinueAsGuest}
                                style={{
                                    padding: '16px',
                                    background: theme.colors.accent,
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    boxShadow: theme.shadows.md,
                                }}
                            >
                                👤 Continue as Guest
                            </button>
                            <button
                                onClick={handleLogin}
                                style={{
                                    padding: '16px',
                                    background: theme.colors.primary,
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    boxShadow: theme.shadows.md,
                                }}
                            >
                                🔐 Sign In / Create Account
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h2 style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            color: theme.colors.textPrimary,
                            marginBottom: '8px',
                        }}>
                            What's your name?
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: theme.colors.textSecondary,
                            marginBottom: '24px',
                        }}>
                            {isGuest ? 'Guest Player' : 'Player'}
                        </p>

                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <input
                                type="text"
                                placeholder="Enter your name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                autoFocus
                                style={{
                                    padding: '14px',
                                    fontSize: '16px',
                                    borderRadius: '10px',
                                    border: `2px solid ${theme.colors.cardBorder}`,
                                    color: theme.colors.textPrimary,
                                    background: theme.colors.bgPrimary,
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    padding: '14px',
                                    background: theme.colors.accent,
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    boxShadow: theme.shadows.md,
                                }}
                            >
                                Start Playing 🎮
                            </button>
                            <button
                                type="button"
                                onClick={() => setMode('choice')}
                                style={{
                                    padding: '12px',
                                    background: 'transparent',
                                    color: theme.colors.textSecondary,
                                    border: `1px solid ${theme.colors.cardBorder}`,
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                }}
                            >
                                ← Back
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default Welcome;
